@let mobile = isMobile();
<div class="header wh-100-background w-100">
  <div
    class="header-row d-flex flex-row align-items-center justify-content-between psic-gap-8"
    [class.psic-px-8]="!mobile"
    [class.psic-py-4]="!mobile"
    [class.psic-px-6]="mobile"
    [class.psic-py-1]="mobile"
  >
    <!-- Left: PSIC Logo -->
    @if(mobile){
    <img
      class="psic-logo pointerCursor"
      src="../../../../assets/images/PSIC-logo-horizontal-reduced.svg"
      alt="psic-logo"
      (click)="goToHome()"
    />
    } @else {
    <img
      class="psic-logo pointerCursor"
      src="../../../../assets/images/psic_logo.svg"
      alt="psic-logo"
      (click)="goToHome()"
    />
    }

    <!-- Right: Toll Number + Sign Out -->
    <div class="d-flex flex-row align-items-center psic-gap-6">
      <!-- theme dropdown-->
      @if (!isProduction && !mobile && !pageLoaderService.isDocumentUploadLoading()) {
      <select
        class="psic-br-4 psic-p-2"
        (change)="onThemeChange($event)"
        [(ngModel)]="defaultTheme"
      >
        @for (theme of themes; track theme) {
        <option [value]="theme.value">{{ theme.label }}</option>
        }
      </select>
      }
      <div class="d-flex flex-row align-items-center psic-gap-2">
        <div class="d-flex flex-column align-items-end justify-center">
          <span class="disclaimer">Need help? Call us</span>
          <span class="disclaimer-bold">{{ globalMessage.psicTollNumber }}</span>
        </div>
        <mat-icon [svgIcon]="'phone'" class="mat-icon-24 dg-60-color"></mat-icon>
      </div>
      @if (isAuthenticated()) {
      <div class="d-flex flex-row align-items-center psic-gap-2 pointerCursor" (click)="signOut()">
        @if (!mobile) {
        <span class="disclaimer">Sign out</span>
        }
        <mat-icon [svgIcon]="'log-out'" class="mat-icon-24 dg-60-color"></mat-icon>
      </div>
      }
    </div>
  </div>
</div>
